/* MX Blog – Beitragsseite Template v3 (15.10.2026)
   Video, Zeitmarken und „In den Warenkorb“ laufen über mx-shop.js ([data-yt-jump], [data-yt-go], [data-mxs-add]).
   Hier: Variantenwahl, Kapitel-Wischleiste, Lesefortschritt, Inhalt (Seitenleiste/Handy), feste Leiste unten. */
(function () {
  var root = document.querySelector('.mxs-art');
  if (!root) return;
  document.documentElement.classList.add('mxb-js');

  // Variante wählen -> Preis und Warenkorb-Knopf anpassen
  root.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-mxb-sel]');
    if (!s) return;
    var row = s.closest('.mxb-pk__row'), o = s.options[s.selectedIndex];
    var p = row && row.querySelector('[data-price]'), b = row && row.querySelector('[data-mxs-add]');
    if (p && o) p.textContent = o.getAttribute('data-p');
    if (b && o) { b.setAttribute('data-mxs-add', o.value); b.disabled = o.disabled; }
  });

  // Kapitel-Wischleiste: Pfeile, Ausblendung am Ende
  var ch = root.querySelector('.mxb-ch'), nav = root.querySelectorAll('[data-chnav]');
  function chState() {
    if (!ch) return;
    var end = ch.scrollLeft + ch.clientWidth >= ch.scrollWidth - 4;
    ch.classList.toggle('is-end', end);
    for (var i = 0; i < nav.length; i++) nav[i].disabled = (+nav[i].getAttribute('data-chnav') < 0) ? ch.scrollLeft <= 2 : end;
  }
  for (var i = 0; i < nav.length; i++) nav[i].addEventListener('click', function () {
    var li = ch.querySelector('li'), step = li ? (li.getBoundingClientRect().width + 10) * 2 : 400;
    ch.scrollBy({ left: step * (+this.getAttribute('data-chnav')), behavior: 'smooth' });
  });
  if (ch) { ch.addEventListener('scroll', chState, { passive: true }); chState(); }

  // Inhalt am Handy: nach dem Sprung wieder einklappen
  var tm = root.querySelector('.mxb-toc-m');
  if (tm) tm.addEventListener('click', function (e) { if (e.target.closest('a')) tm.open = false; });

  // Lesefortschritt, Inhalt in der Seitenleiste, feste Leiste unten
  var bar = document.querySelector('.mxb-prog span'), txt = root.querySelector('.mxs-art__body');
  var links = Array.prototype.slice.call(root.querySelectorAll('.mxb-stoc a'));
  var targets = links.map(function (l) { return document.getElementById(l.getAttribute('href').slice(1)); });
  var mbar = document.querySelector('.mxb-bar'), vid = document.getElementById('video'), cta = document.getElementById('anfrage');
  var foot = document.querySelector('.shopify-section-group-footer-group, footer');
  var tick = false;
  function update() {
    tick = false;
    var vh = window.innerHeight;
    if (bar && txt) {
      var r = txt.getBoundingClientRect(), h = r.height - vh * 0.6;
      bar.style.width = (Math.min(1, Math.max(0, (-r.top + vh * 0.25) / (h > 0 ? h : 1))) * 100).toFixed(2) + '%';
    }
    if (links.length) {
      var y = 140, cur = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= y) cur = i; });
      links.forEach(function (l, i) { l.classList.toggle('is-on', i === cur); });
    }
    if (mbar) {
      var past = vid && vid.getBoundingClientRect().bottom < 0;
      var ctaVis = cta && cta.getBoundingClientRect().top < vh && cta.getBoundingClientRect().bottom > 0;
      var footVis = foot && foot.getBoundingClientRect().top < vh;
      mbar.classList.toggle('is-on', !!(past && !ctaVis && !footVis));
    }
  }
  function onScroll() { if (!tick) { tick = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { chState(); onScroll(); });
  update();
})();
